import { computed, ref } from "vue";
import { useStore } from 'vuex';
import Helpers from "../../helpers";

export function useLeads() {

    const store = useStore();
    const spinner = ref(false);
    const filter = ref({

    })

    const getLeads = async (page = 1) => {
        const filterData = Helpers.eliminarNull(filter.value);
        await store.dispatch('appLeads/getLeadsAction', { filters: filterData, page })
            .then(() => {
                spinner.value = false
            })
            .catch(() => { });
    };


    const headers = [
        { field: "id", key: 'id', label: "Código" },
        { field: "nombre", label: "Nombre" },
        { field: "main_mail", label: "Correo" },
        { field: "main_cell_phone", label: "Celular" },
        { field: "subportalescode", label: "Proppit" },
        { field: "portalescontact", label: "Portal" },

        { field: 'actions',  label: "Acciones" }
    ];

    const leads = computed(() => {
        return store.state.appLeads.leads;
    })


    return {
        headers,
        getLeads,
        filter,
        leads,

    }
}
